module.exports = __webpack_public_path__ + "img/climateLife.3298bc40.png";